"use client";
import SectionRetry from "@casino/client/components/SectionRetry";
import Log from "@workspace/nextjs_utils/src/Log";
import { type ReactNode, useState, useTransition } from "react";

type Props = {
  title: string;
  message: string;
  retryLabel: string;
  retry: () => Promise<ReactNode>;
};

const AllGamesRetry: FC<Props> = ({ title, message, retryLabel, retry }) => {
  const [section, setSection] = useState<ReactNode>(null);
  const [isPending, startTransition] = useTransition();

  if (section) {
    return section;
  }

  const onRetry = () =>
    startTransition(async () => {
      try {
        setSection(await retry());
      } catch (error) {
        Log.error("[AllGamesRetry]: retry request failed", { error });
      }
    });

  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-lg font-semibold text-foreground">{title}</h2>
      <SectionRetry
        message={message}
        retryLabel={retryLabel}
        isPending={isPending}
        onRetry={onRetry}
      />
    </section>
  );
};

export default AllGamesRetry;
